<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="分类用途：" prop="purposeTypes" class="width100">
          <el-select v-model="form.purposeTypes" multiple placeholder="请选择">
            <el-option label="类型考试" :value="1"></el-option>
            <el-option label="类型练习" :value="2"></el-option>
            <el-option label="课程考试" :value="3"></el-option>
            <el-option label="闯关考试" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试卷分类：" prop="name" class="width100">
          <el-input v-model="form.name" placeholder="请输入试卷分类名称" />
        </el-form-item>
        <template v-if="form.purposeTypes && form.purposeTypes.includes(1)">
          <el-form-item label="考试达标分数：" prop="achievementScore">
            <el-input v-model="form.achievementScore" placeholder="请输入考试达标分数" />
          </el-form-item>
          <el-form-item label="考试学分：" prop="examCredits">
            <el-input v-model="form.examCredits" placeholder="请输入考试学分" />
          </el-form-item>
          <el-form-item label="考试题数：" prop="examNum" >
            <el-input v-model="form.examNum" placeholder="请输入考试题数" />
          </el-form-item>
          <el-form-item label="单题分数：" prop="examSingleScore">
          <el-input v-model="form.examSingleScore" placeholder="请输入每道题得分">
            <i class="el-input__icon" slot="suffix">分</i>
          </el-input>
          </el-form-item>
          <el-form-item label="总分：">
            <el-input v-model="examTotalScore" placeholder="根据单题分数和考试题数算出总分" disabled>
              <i class="el-input__icon" slot="suffix">分</i>
            </el-input>
          </el-form-item>
          <el-form-item label="是否能看答案：" prop="isLookSolution">
            <el-select v-model="form.isLookSolution" placeholder="请选择">
              <el-option label="允许查看" :value="1"></el-option>
              <el-option label="不允许查看" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试次数：">
            <el-input v-model="form.examOrder" placeholder="请输入考试次数" />
          </el-form-item>
          <el-form-item label="考试时间范围：" >
            <el-date-picker v-model="form.dateTime" size="small" type="datetimerange" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="考试时长：" >
            <el-input v-model="form.examDuration" placeholder="请输入考试时长">
              <i slot="suffix" class="el-input__icon">分钟</i>
            </el-input>
          </el-form-item>
        </template>
        <el-form-item label="状态：" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { accMul } from '@/utils/index'
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'
function initFormBean() {
  const formBean = {
    purposeTypes: [],
    name: null,
    achievementScore: null,
    examCredits: null,
    examNum: null,
    isLookSolution: null,
    examOrder: null,
    dateTime: [],
    examDuration: null,
    state: 0,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        purposeTypes: [{ required: true, message: '请选择分类用途', trigger: 'change' }],
        name: [{ required: true, message: '请输入试卷分类名称', trigger: 'blur' }],
        achievementScore: [{ required: true, message: '请输入考试达标分数', trigger: 'blur' }],
        examCredits: [{ required: true, message: '请输入考试学分', trigger: 'blur' }],
        examNum: [{ required: true, message: '请输入考试题数', trigger: 'blur' }],
        isLookSolution: [{ required: true, message: '请选择是否能看答案', trigger: 'change' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  computed: {
    examTotalScore() {
      let score = null
      let { examNum, examSingleScore } = this.form
      if (examNum && examSingleScore) {
        score = accMul(examNum, examSingleScore)
        this.form.examTotalScore = score
      }
      return score
    }
  },
  methods: {
    // disabledMinutes() {
    //   let arr = [];
    //   for (let i = 0; i < 60; i++) {
    //     if (i % 5 !== 0) {
    //       arr.push(i);
    //     }
    //   }
    //   return arr;
    // },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      // 将逗号隔开的字符串转换为数组
      if (row.purposeTypes && typeof row.purposeTypes === 'string') {
        this.$set(this.form, 'purposeTypes', row.purposeTypes.split(',').map(item => parseInt(item)))
      } else if (row.purposeTypes && Array.isArray(row.purposeTypes)) {
        this.$set(this.form, 'purposeTypes', row.purposeTypes)
      } else {
        this.$set(this.form, 'purposeTypes', [])
      }
      if (row.startTime && row.endTime) this.$set(this.form, 'dateTime', [row.startTime.substr(row.startTime, row.startTime.lastIndexOf(':')), row.endTime.substr(row.endTime, row.endTime.lastIndexOf(':'))])
      else this.$set(this.form, 'dateTime', [])
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form));
      if (params.dateTime && params.dateTime.length > 0) {
        params.startTime = params.dateTime[0] + ':00'
        params.endTime = params.dateTime[1] + ':00'
      }
      // 检查是否包含类型考试（值为1）
      const hasTypeExam = params.purposeTypes && Array.isArray(params.purposeTypes) && params.purposeTypes.includes(1)
      // 将数组转换为逗号隔开的字符串
      if (params.purposeTypes && Array.isArray(params.purposeTypes)) {
        params.purposeTypes = params.purposeTypes.join(',')
      }
      if (hasTypeExam) {
        params.examDuration = +params.examDuration || ''
        params.examNum = +params.examNum || ''
        params.examOrder = +params.examOrder || ''
      }
      // delete params.createdTime
      // delete params.operatedTime
      // delete params.operatedBy
      delete params.dateTime
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            courseTopicClassificationApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            courseTopicClassificationApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }

        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
.el-time-spinner__item.is-disabled {
  display: none;
}
</style>
